class MetricManager {
  constructor(data) {
    this.data = data;
    this.hraCompleted = this.HraCompletedCount(this.data);
    this.totalCustomers = this.totalCustomerCount(this.data);
    this.hraCompletedPercetage = this.customersCompletedHraPercentage();
    this.notCompletedHra = this.customersNotCompletedHra(this.data);
    this.donutData = this.donutGraphData();
  }

  apiResponse() {
    return this.data;
  }

  customersNotCompletedHra(data) {
    return data.customer_count - data.hra_count;
  }

  HraCompletedCount(data) {
    return data.hra_count;
  }

  totalCustomerCount(data) {
    return data.customer_count;
  }

  customersCompletedHraPercentage() {
    return this.floorPercentage(this.hraCompleted, this.totalCustomers);
  }

  floorPercentage(numerator, denominator) {
    return Math.round((numerator / denominator) * 100);
  }

  donutGraphData() {
    let result = [];
    if (this.data.hra_count) {
      result.push({
        number: this.data.hra_count,
        percentage: this.hraCompletedPercetage,
        color: '#60A5FA',
      });
      result.push({
        number: this.notCompletedHra,
        percentage: 100 - this.hraCompletedPercetage,
        color: '#E5E7EB',
      });
    }

    return result;
  }
}

export default MetricManager;
